import { PatentListData } from "@/components/business/PatentContainer/Patent.types";
import { ProcessStatusCode } from "@/types/code.types";
import { useCreateEntryDataMutation } from "@api/createEntryData/createEntryData";
import { DRAFT_STATUS_CODE } from "@constants/draftStatusCode.constants";
import { handlePatentListError } from "@utils/handleDraftError";

import PatentStatus from "./components/PatentStatus/PatentStatus";

type Props = {
  data: PatentListData;
};

const PatentStatusContainer = ({ data }: Props) => {
  const { mutateAsync: createEntryData } = useCreateEntryDataMutation();

  const checkDisabledStatusButton = (status: ProcessStatusCode) => {
    if (status !== DRAFT_STATUS_CODE.aiEntryDone) return false;
    return true;
  };

  const createDAE = (id: number) => {
    createEntryData(id);
  };

  return (
    <PatentStatus
      data={data}
      isDraftError={handlePatentListError(data)[0]}
      draftErrorMessage={handlePatentListError(data)[1]}
      createDAE={createDAE}
      disabled={checkDisabledStatusButton(data.draftArticleStatusHighest)}
    />
  );
};

export default PatentStatusContainer;
